// Transitions
export const FORM_VALID_TRANSITION_UPLOADD_OCUMENTS =
  "sizotsaFuneralClaim/uploadDocuments/transition/formValid";
export const FORM_INVALID_TRANSITION_UPLOADD_OCUMENTS =
  "sizotsaFuneralClaim/uploadDocuments/transition/formInvalid";
export const UPLOAD_DOCUMENTS_FORM_SET_VALUE =
  "sizotsaFuneralClaim/uploadDocuments/transition/formValue";
export const setPersonalDetailFormValues = () => ({
  type: UPLOAD_DOCUMENTS_FORM_SET_VALUE,
});

export const transitionUploadDocuments = {
  formValid: () => ({ type: FORM_VALID_TRANSITION_UPLOADD_OCUMENTS }),
  formInvalid: () => ({ type: FORM_INVALID_TRANSITION_UPLOADD_OCUMENTS }),
};

export const INVALID_CONTINUE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/uploadDocuments/transition/invalidContinue";
export const CONTINUE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/uploadDocuments/transition/validContinue";
export const BACK_TRANSITION_PERSONAL_DETAIL =
  "sizotsaFuneralClaim/uploadDocuments/transition/back";
export const invalidContinuePersonalDetails = () => ({
  type: INVALID_CONTINUE_TRANSITION_PERSONAL_DETAILS,
});
export const continuePersonalDetails = () => ({
  type: CONTINUE_TRANSITION_PERSONAL_DETAILS,
});
export const backPersonalDetails = () => ({
  type: BACK_TRANSITION_PERSONAL_DETAIL,
});

// Transition - reset state
export const RESET_STATE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/uploadDocuments/transition/resetState";
export const resetPersonalDetails = () => ({
  type: RESET_STATE_TRANSITION_PERSONAL_DETAILS,
});
export const SZ_CLAIM_UPLOAD_DOCUMENT="sizotsaFuneralClaim/uploadDocuments/"
// Events
export const PERSONAL_DETAILS_CLEAR_VALUE =
  "sizotsaFuneralClaim/uploadDocuments/clearValue/";
export const UPLOAD_DOCUMENTS_SET_VALUE =
SZ_CLAIM_UPLOAD_DOCUMENT+ "setValue/";
export const UPLOAD_DOCUMENTS_FILE_SET_VALID =
  "sizotsaFuneralClaim/uploadDocuments/setValid/";

  //

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/uploadDocuments/transition/dropOffLead";
export const dropOffLeadPersonalDetails = (dropOffDetails) => ({
  type: DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS,
  dropOffDetails,
});


export const setUploadDocumentsValue =(value)=>({type: UPLOAD_DOCUMENTS_SET_VALUE, value})
export const setUploadDocumentsFileValid =(error,fieldType)=>( {type: UPLOAD_DOCUMENTS_FILE_SET_VALID, error, fieldType})
  
